import { supabase, isSupabaseConfigured } from '../../supabase';
import { useStore } from '../../../store/useStore';

/**
 * Interface for lead search criteria
 */
export interface LeadSearchCriteria {
  city?: string;
  state?: string;
  status?: string;
  min_equity?: number;
  max_equity?: number;
  min_value?: number;
  max_value?: number;
  query?: string; // for name/address/email/phone
}

/**
 * Tool to search leads in the Supabase database with dynamic filters
 */
export async function searchLeads(criteria: LeadSearchCriteria) {
  if (!isSupabaseConfigured || !supabase) {
    console.error('[Lead Search] Supabase not configured');
    return [];
  }

  const userId = useStore.getState().currentUser?.id;
  if (!userId) {
    console.error('[Lead Search] No user ID found');
    return [];
  }

  console.log('[Lead Search] Searching for leads with criteria:', criteria);

  try {
    let query = supabase
      .from('leads')
      .select('id, name, email, phone, address, city, state, status, estimated_equity, property_value, deal_score')
      .eq('created_by', userId); // Privacy: only user's leads

    if (criteria.city) {
      query = query.ilike('city', `%${criteria.city}%`);
    }
    if (criteria.state) {
      query = query.ilike('state', `%${criteria.state}%`);
    }
    if (criteria.status) {
      query = query.eq('status', criteria.status);
    }
    if (criteria.min_equity !== undefined) {
      query = query.gte('estimated_equity', criteria.min_equity);
    }
    if (criteria.max_equity !== undefined) {
      query = query.lte('estimated_equity', criteria.max_equity);
    }
    if (criteria.min_value !== undefined) {
      query = query.gte('property_value', criteria.min_value);
    }
    if (criteria.max_value !== undefined) {
      query = query.lte('property_value', criteria.max_value);
    }
    
    if (criteria.query) {
      // Search in multiple fields using or
      query = query.or(`name.ilike.%${criteria.query}%,address.ilike.%${criteria.query}%,email.ilike.%${criteria.query}%,phone.ilike.%${criteria.query}%`);
    }

    const { data, error } = await query.limit(50).order('created_at', { ascending: false });

    if (error) {
      console.error('[Lead Search] Error searching leads:', error);
      return [];
    }

    console.log(`[Lead Search] Found ${data?.length || 0} leads`);
    return data || [];
  } catch (error) {
    console.error('[Lead Search] Unexpected error:', error);
    return [];
  }
}
